import { createFileRoute } from "@tanstack/react-router";
import { Landing } from "@/components/Landing";

export const Route = createFileRoute("/")({
  component: Landing,
  head: () => ({
    meta: [
      { title: "InLiveShop — Compras ao Vivo. Energia em Tempo Real." },
      {
        name: "description",
        content:
          "A arena de live commerce de nova geração. Transmita, dê lances e ganhe. Transforme compras em uma experiência ao vivo e gamificada.",
      },
      { property: "og:title", content: "InLiveShop — Compras ao Vivo. Energia em Tempo Real." },
      {
        property: "og:description",
        content: "Leilões ao vivo, chat em tempo real e drops gamificados. Entre na lista de espera.",
      },
    ],
  }),
});
